<!--
 
 
 // bookname, volnum, years, pagecount, banben, bookid, pageid, exam, keyword, isImg2,textFirst,img1First,img1Num,img2Num   // 14ä¸ª
   
    var banbenInfo = T_banben+":"+T_banben2+":"+T_author;
 
	var M_str = 
    T_bookName+',,'+T_time+','+T_totalpages+','+banbenInfo+','+T_bookId+','+T_pageId+',,,'+T_isImg2+',1,'+T_img1First+',' + T_img1Num+','+ T_img2Num;

-->


<template>
  <div id="bookShelfCanvas">
        <span v-show="loading">
            æ­£åœ¨åŠ è½½... 
        </span>
        <span v-show="!loading">
            <span v-if="this.bookMarkMap != null">
                <ul>
                    <li v-for="(value, key) in bookMarkMap" :key="key">
                        <bookMarkBox :bookName= "value[0]" :markList= "value[1]" ></bookMarkBox>
                    </li>
                </ul>
            </span>
            <span v-else>
                <span v-show="loading">
                   æ‚¨è¿˜æœªæ·»åŠ å›¾ä¹¦
                </span>
            </span>              
        </span>
 
  </div>
</template>

<script>

import bookMarkBox from '@/components/book_mark/book_mark_box.vue' 
export default {
  components: {
      bookMarkBox
  },
  data () {
    return {
        loading: true,
        resultArray: [],
        bookMarkMap: Map
    }
  },
  methods: {
    jump2Search () {
        this.loadBookShelf()
    },
    loadBookShelf () {

        let currLIbId = this.$store.state.libId
        const api = '/spring/front/user/getBookMark'
        const params = {
            num:50,   //æœ€å¤§åŠ è½½ä¸ªæ•°
            libId: currLIbId
        }
       
        let that = this  //å­˜å‚¨this
        this.axios.post(api, this.$stringify(params)).then(res => {

            that.loading = false
            console.log(res.status)
             // eslint-disable-next-line no-debugger
            debugger
            if (res.status !== 200) {
                return
            }
            //res = res.data
            that.resultArray = res.data
            //console.log("ss")
            //this.$alert(resMap.info, 'æ��ç¤º')

            /*
emBookName: " æ˜“è±¡æ„�è¨€1å�·"
emBookPage: 1
emCateName: " æ˜“è±¡æ„�è¨€1å�·,,å®‹,57,æ­¦è‹±æ®¿è�šç��ç‰ˆæ›¸æœ¬:è—�æµ·ç� å¡µæœ¬:ï¼ˆå®‹ï¼‰è”¡æ·µæ’°,08985,1,,,true,1,1,57,48"
emId: 28
emInfo: "æš‚æ— ..."
emIsBookShelf: 0
emJournalDate: null
emLibId: "885"
            
            */

            this.resetMarkInfoMap()
           
       })
    },
    resetMarkInfoMap () {
        let markMap = new Map()
        let markArray = new Array()
        if(this.resultArray != null && this.resultArray.length > 0){
                let len = this.resultArray.length
                let _mark
                let _bookname
                for (let i = 0; i < len; i++) {
                    _mark = this.resultArray[i];

                    _bookname = _mark.emBookName
                    _bookname = _bookname.replace(/^\s*/,"");

                    markArray = markMap.get(_bookname)
                    if(markArray == null){
                        markArray = new Array()
                    }
                    markArray.push(_mark)
                    markMap.set(_bookname,markArray)  
                }

                this.bookMarkMap = markMap
        }
    }
    ,
    delMadrkInfoById(id) {
        //this.$alert("666" + id)
        const api = '/spring/front/user/delthemark'
        const params = {
            mid:id   //æœ€å¤§åŠ è½½ä¸ªæ•°
        }
       
        let that = this  //å­˜å‚¨this
        this.axios.post(api, this.$stringify(params)).then(res => {
            // console.log(res.status)
            if (res.status !== 200) {
                this.$alert("ç½‘ç»œå¼‚å¸¸ï¼Œè¯·é‡�è¯•", 'æ��ç¤º')
                return
            }
            // eslint-disable-next-line no-debugger
            debugger
            if (res.data == "ok") {
                for (let index = 0; index < that.resultArray.length; index++) {
                    const element = that.resultArray[index];
                    if(element.emId == id){
                       that.resultArray.splice(index, 1);

                       that.resetMarkInfoMap()

                       break
                    }
                }
            }
            else{
                this.$alert("æœ�åŠ¡ç«¯æŽ¥æ”¶å�‚æ•°å¼‚å¸¸", 'æ��ç¤º')
            }
            //this.$alert(resMap.info, 'æ��ç¤º')
       })
    }
  },
  // ç”Ÿå‘½å‘¨æœŸ - åˆ›å»ºå®Œæˆ�ï¼ˆè®¿é—®å½“å‰�thiså®žä¾‹ï¼‰
  created () {

  },
  // ç”Ÿå‘½å‘¨æœŸ - æŒ‚è½½å®Œæˆ�ï¼ˆè®¿é—®DOMå…ƒç´ ï¼‰
  mounted () {
    this.loadBookShelf()
  }
}
</script>
<style scoped>
/* @import url(); å¼•å…¥cssç±» */

#bookShelfCanvas{
    width: 100%;
    height: calc(100vh - 63px);
    overflow-y: auto;


    background: url(/static/images/researchroom/book_shelf_bg.png);
    
    /*
    filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod='scale')";
    -moz-background-size: 100% 100%;
    background-size: 100% 100%;
    */
    
}

#bookShelfCanvas ul li{
    width: 300px;
    height: 481px;
    display: inline-block;
    padding: 10px;
}

#bookShelfCanvas ul{
    
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    display: inline-flex;
    flex-direction: row;
    flex-wrap:wrap;
    justify-content: left;
  

    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
     
}

.bookBox{
    width: 220px;
    height: 350px;
    overflow: hidden;
    position: relative;

}

.bookName{
    position:absolute;
    top: 30px;
    left: 45px;
    height: 280px;
    width: 30px;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    justify-content:center;
   

}

.bookNameInfo{
    height: auto;
}

</style>
